export var Unit;
(function (Unit) {
    Unit["Std."] = "Std.";
    Unit["m"] = "m";
    Unit["m^2"] = "m^2";
    Unit["m^3"] = "m^3";
    Unit["ha"] = "ha";
    Unit["kg"] = "kg";
    Unit["t"] = "t";
    Unit["St\u00FCck"] = "St\u00FCck";
    Unit["fix"] = "fix";
    Unit["Fahrt"] = "Fahrt";
    Unit["km"] = "km";
})(Unit || (Unit = {}));
var Service = /** @class */ (function () {
    function Service() {
    }
    return Service;
}());
export { Service };
var MeasurementUnit = /** @class */ (function () {
    function MeasurementUnit(unit, diameter) {
        if (diameter === void 0) { diameter = null; }
        this.unit = unit.unit;
        this.estimatedQuantity = +unit.estimatedQuantity;
        this.diameter = diameter;
        if (unit.basePrice || unit.basePrice === 0) {
            this.basePrice = +unit.basePrice;
        }
        if (unit.netPrice || unit.netPrice === 0) {
            this.netPrice = +unit.netPrice;
        }
        if (unit.taxPrice || unit.taxPrice === 0) {
            this.taxPrice = +unit.taxPrice;
        }
        this.workedQuantity = unit.workedQuantity ? +unit.workedQuantity : 0;
        this.actualQuantity = unit.actualQuantity ? +unit.actualQuantity : 0;
        this.setActualQuantity(unit.workedQuantity, unit.actualQuantity);
    }
    MeasurementUnit.prototype.addWorkedQuantity = function (workedQuantity, actualQuantity) {
        this.workedQuantity += workedQuantity;
        this.setActualQuantity(actualQuantity);
    };
    MeasurementUnit.prototype.setActualQuantity = function (workedQuantity, actualQuantity) {
        if (actualQuantity) {
            return;
        }
        if (this.unit !== Unit['Std.']) {
            this.actualQuantity += workedQuantity;
            return;
        }
        var integralPart = Math.trunc(workedQuantity);
        var digits = (workedQuantity - integralPart) * 100; // 0.01 , 0.36, 0.99
        if (digits <= 0) {
            this.actualQuantity += workedQuantity;
            return;
        }
        if (digits <= 25) {
            this.actualQuantity += integralPart + 0.25;
        }
        else if (digits <= 50) {
            this.actualQuantity += integralPart + 0.5;
        }
        else if (digits <= 75) {
            this.actualQuantity += integralPart + 0.75;
        }
        else {
            this.actualQuantity += integralPart + 1;
        }
    };
    Object.defineProperty(MeasurementUnit.prototype, "totalPrice", {
        get: function () {
            var diameter = this.diameter || 1;
            return diameter * this.actualQuantity * this.netPrice + this.basePrice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasurementUnit.prototype, "vatPrice", {
        get: function () {
            if (this.taxPrice === 0) {
                return 0;
            }
            return 1 + this.taxPrice / 100;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasurementUnit.prototype, "grossPrice", {
        get: function () {
            return this.netPrice * this.vatPrice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasurementUnit.prototype, "totalGrossPrice", {
        get: function () {
            return this.totalPrice * this.vatPrice;
        },
        enumerable: true,
        configurable: true
    });
    return MeasurementUnit;
}());
export { MeasurementUnit };
export var ServiceType;
(function (ServiceType) {
    ServiceType["basic"] = "klassisch";
    ServiceType["straw"] = "ballen";
})(ServiceType || (ServiceType = {}));
